import type { FunctionComponent } from 'react';
import { Inline } from '@atlaskit/primitives/compiled';

import Logo from './Logo';
import ChangesIcon from '@atlaskit/icon/core/changes';
import AtlassianUserIcon from './AtlassianUserIcon';

const AppLogos: FunctionComponent = () => (
  <Inline alignBlock="center" space="space.100">
    <Logo />
    <ChangesIcon label="" />
    <AtlassianUserIcon />
  </Inline>
);

export default AppLogos;
